import { BaseConfig } from '../ServiceConfig';

export interface OmniBffConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.OmniBffConfigData';
  consumerBffUrl: string;
  staffBffUrl: string;
}

export const OmniBffConfigurationFields: (keyof OmniBffConfiguration)[] = [
  'consumerBffUrl',
  'staffBffUrl'
];

export const BlankOmniBffConfiguration: OmniBffConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.OmniBffConfigData',
} as OmniBffConfiguration;
